
import React, {
  Component,
  PropTypes,
} from 'react';

export default class GuidePageSideNav extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="guidePageSideNav">
        <div className="guidePageSideNav__title">
          {this.props.title}
        </div>

        <div className="guidePageSideNavMenu">
          {this.props.children}
        </div>
      </div>
    );
  }

}

GuidePageSideNav.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
};



/** WEBPACK FOOTER **
 ** ./src/guide/components/guide_page_side_nav/guide_page_side_nav.jsx
 **/